<div class="mt-4">
    <ca-tabs-group (changeTab)="onChangeTab($event)">
        <ca-tab label="{{'AUTOS.BUSCADOR_MODELOS.MATRICULA.TITULO' | translate}}">
            <ca-card>
                <div ca-card-content>
                    <app-buscar-version-matricula></app-buscar-version-matricula>
                </div>
            </ca-card>
        </ca-tab>
        <ca-tab label="{{'AUTOS.BUSCADOR_MODELOS.MANUAL.TITULO' | translate}}">
            <ca-card>
                <div ca-card-content>
                    <app-buscar-version-manual></app-buscar-version-manual>
                </div>
            </ca-card>
        </ca-tab>
        <ca-tab label="{{'AUTOS.RECUPERAR.BOTON' | translate}}">
            <ca-card>
                <div ca-card-content>
                    <app-recuperar-proyecto></app-recuperar-proyecto>
                </div>
            </ca-card>
        </ca-tab>
    </ca-tabs-group>
</div>
<div class="mt-3" *ngIf="registros?.length > 0">
    <ca-card>
        <div ca-card-title>{{'AUTOS.BUSCADOR_MODELOS.TABLA_VERSIONES.TITULO' | translate}}</div>
        <div ca-card-content>
            <ca-tabla-seguros 
                [registros]="registros" 
                [columnas]="columnas" 
                [tamanoPagina]="10" 
                [registroSeleccionable]="true"
                [paginado]="true"
                (registroSeleccionadoEvent)="seleccionarRegistro($event)" ></ca-tabla-seguros>

            <div class="col-12 text-right mt-3 mb-3">
                <button ca-button class="ca-btn-icon__container ml-2" (click)="simularPoliza()" [disabled]="!registrosSeleccionado">
                    <ca-icon>chevron_right</ca-icon>
                    {{'BUSCADOR_POLIZAS.BOTON_CONTINUAR' | translate}}                        
                </button>
            </div>   
        </div> 
    </ca-card>
</div>
